import { render, staticRenderFns } from "./MobileChat.vue?vue&type=template&id=c4402c72"
import script from "./MobileChat.vue?vue&type=script&lang=js"
export * from "./MobileChat.vue?vue&type=script&lang=js"
import style0 from "./MobileChat.vue?vue&type=style&index=0&id=c4402c72&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4402c72')) {
      api.createRecord('c4402c72', component.options)
    } else {
      api.reload('c4402c72', component.options)
    }
    module.hot.accept("./MobileChat.vue?vue&type=template&id=c4402c72", function () {
      api.rerender('c4402c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatGPT3.0/MobileChat.vue"
export default component.exports